import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Features from "./components/Features";
import ResumeBuilder from "./components/ResumeBuilder";
import Footer from "./components/Footer";
import About from "./pages/About"; 
import Contact from "./pages/Contact"; 

function App() {
  return (
    <Router basename="/cv-builder">
      <div className="min-h-screen bg-gray-50">
        <Header />
        <Routes>
          <Route path="/" element={<>
            <Hero />
            <Features />
            <ResumeBuilder />
          </>} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
